import {
  MediumIcon_default
} from "./chunk-45UX6ORQ.mjs";
export {
  MediumIcon_default as default
};
